import React from 'react';
import { DatabaseIcon, CogIcon, LayersIcon, BarChart2Icon } from 'lucide-react';
const Slide4 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2744">
      <div className="flex flex-col space-y-6" data-id="element-2745">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-8" data-id="element-2746">How it works</h2>
        {/* Steps */}
        <div className="max-w-4xl mx-auto" data-id="element-2747">
          <div className="relative" data-id="element-2748">
            {/* Connection line */}
            <div className="absolute left-[42px] top-12 bottom-12 w-1 bg-indigo-200 hidden md:block" data-id="element-2749"></div>
            <div className="space-y-12" data-id="element-2750">
              {/* Step 1 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2751">
                <div className="flex-shrink-0 flex items-start" data-id="element-2752">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2753">
                    <DatabaseIcon className="h-8 w-8" data-id="element-2754" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2755">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2756">
                    1. Ingest & normalize catalog
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2757">
                    We connect to your product catalog through APIs or feeds,
                    then normalize and enrich the data for optimal AI
                    understanding.
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2758">
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2759">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2760"></div>
                      <span data-id="element-2761">Product data</span>
                    </div>
                    <div className="h-2" data-id="element-2762"></div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2763">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2764"></div>
                      <span data-id="element-2765">Inventory & availability</span>
                    </div>
                    <div className="h-2" data-id="element-2766"></div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-2767">
                      <div className="w-2 h-2 bg-indigo-500 rounded-full" data-id="element-2768"></div>
                      <span data-id="element-2769">Pricing & promotions</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Step 2 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2770">
                <div className="flex-shrink-0 flex items-start" data-id="element-2771">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2772">
                    <CogIcon className="h-8 w-8" data-id="element-2773" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2774">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2775">
                    2. Consultative engine → best fit
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2776">
                    Our AI engine uses consultative selling techniques to
                    understand customer needs and match them with the best
                    products.
                  </p>
                  <div className="flex flex-wrap gap-2 mb-3" data-id="element-2777">
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2778">
                      Bundles
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2779">
                      Filters
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2780">
                      Coupons
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2781">
                      Subscriptions
                    </span>
                    <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2782">
                      Loyalty-aware
                    </span>
                  </div>
                </div>
              </div>
              {/* Step 3 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2783">
                <div className="flex-shrink-0 flex items-start" data-id="element-2784">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2785">
                    <LayersIcon className="h-8 w-8" data-id="element-2786" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2787">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2788">
                    3. Orchestrate channels
                  </h3>
                  <p className="text-gray-700" data-id="element-2789">
                    We deploy your AI shopping advisors across all customer
                    touchpoints, ensuring consistent experiences and seamless
                    handoffs.
                  </p>
                </div>
              </div>
              {/* Step 4 */}
              <div className="flex flex-col md:flex-row gap-6" data-id="element-2790">
                <div className="flex-shrink-0 flex items-start" data-id="element-2791">
                  <div className="bg-indigo-600 text-white rounded-full w-20 h-20 flex items-center justify-center text-xl font-bold z-10" data-id="element-2792">
                    <BarChart2Icon className="h-8 w-8" data-id="element-2793" />
                  </div>
                </div>
                <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200 flex-grow" data-id="element-2794">
                  <h3 className="text-xl font-semibold text-indigo-800 mb-3" data-id="element-2795">
                    4. Measure & optimize
                  </h3>
                  <p className="text-gray-700 mb-3" data-id="element-2796">
                    Continuous improvement through analytics, A/B testing, and
                    learning from customer interactions.
                  </p>
                  <div className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2797">
                    <div className="space-y-2" data-id="element-2798">
                      <div data-id="element-2799">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2800">
                          <span data-id="element-2801">Conversion Rate</span>
                          <span data-id="element-2802">+24%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2803">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '74%'
                        }} data-id="element-2804"></div>
                        </div>
                      </div>
                      <div data-id="element-2805">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2806">
                          <span data-id="element-2807">Average Order Value</span>
                          <span data-id="element-2808">+18%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2809">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '68%'
                        }} data-id="element-2810"></div>
                        </div>
                      </div>
                      <div data-id="element-2811">
                        <div className="flex justify-between text-xs text-gray-600 mb-1" data-id="element-2812">
                          <span data-id="element-2813">Customer Satisfaction</span>
                          <span data-id="element-2814">92%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2815">
                          <div className="bg-indigo-600 h-2 rounded-full" style={{
                          width: '92%'
                        }} data-id="element-2816"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide4;